<template>
  <div class="reject-reason-field">
    <p v-if="hint" class="reject-reason-field__hint">{{ hint }}</p>
    <div class="reject-reason-field__chips">
      <el-button
        v-for="reason in reasons"
        :key="reason"
        size="small"
        :type="includesReason(reason) ? 'primary' : 'info'"
        :plain="!includesReason(reason)"
        @click="onPick(reason)"
      >{{ reason }}</el-button>
    </div>
    <el-input
      :model-value="modelValue"
      type="textarea"
      :rows="rows"
      :maxlength="maxlength"
      :show-word-limit="maxlength > 0"
      :placeholder="placeholder"
      @update:model-value="$emit('update:modelValue', $event)"
    />
  </div>
</template>

<script>
import { getRejectReasonPresets, appendRejectReason } from '@/utils/rejectReasons'

export default {
  name: 'AdminRejectReasonField',
  props: {
    modelValue: { type: String, default: '' },
    /** content | image | profile | idcard | withdraw | recharge | partner | refund */
    category: { type: String, default: 'content' },
    rows: { type: Number, default: 3 },
    maxlength: { type: Number, default: 0 },
    placeholder: {
      type: String,
      default: '点击上方常见原因加入，也可自行填写或修改'
    },
    hint: {
      type: String,
      default: '常见原因（点击加入下方，可多选叠加）：'
    },
    /** 额外预设，接在分类预设后面 */
    extraReasons: { type: Array, default: () => [] }
  },
  emits: ['update:modelValue'],
  computed: {
    reasons() {
      const base = getRejectReasonPresets(this.category)
      const extra = (this.extraReasons || []).filter(Boolean)
      return [...base, ...extra.filter((r) => !base.includes(r))]
    }
  },
  methods: {
    includesReason(reason) {
      return String(this.modelValue || '').includes(reason)
    },
    onPick(reason) {
      this.$emit('update:modelValue', appendRejectReason(this.modelValue, reason))
    }
  }
}
</script>

<style scoped>
.reject-reason-field__hint {
  margin: 0 0 8px;
  font-size: 13px;
  color: var(--el-text-color-secondary);
  line-height: 1.4;
}
.reject-reason-field__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 10px;
}
.reject-reason-field__chips :deep(.el-button) {
  margin: 0;
}
</style>
